import { canAccessNavEntry } from '@/layout/dashboard/nav-access'
import { getRouteEntries, routeConfig } from '@/routeConfig'

const routesById = new Map(
    getRouteEntries(routeConfig).map((route) => [route.id, route])
)

/**
 * The gates the router applies to `route`, in the shape `canAccessNavEntry`
 * reads. Roles come from the route's guard (what actually lets the page
 * render), falling back to its nav or section roles.
 */
function accessEntryFor(route) {
    return {
        authRequired: true,
        requiresBilling: route.requiresBilling ?? false,
        requiresFeatureFlag: route.requiresFeatureFlag,
        requiresFlavour: route.requiresFlavour,
        requiresGroupAdmin: route.requiresGroupAdmin,
        roles: route.guardProps?.roles ?? route.nav?.roles ?? route.sectionRoles
    }
}

/** Can the viewer open the route with this `routeConfig` id? */
export function canOpenTourRoute(routeId, access) {
    const route = routesById.get(routeId)
    if (!route) return false
    return canAccessNavEntry(accessEntryFor(route), access)
}

/** Drop tour steps on pages the viewer can't open (role, flag, billing). */
export function filterTourSteps(steps, access) {
    return steps.filter((step) => canOpenTourRoute(step.routeId, access))
}
